import NavBarComponent from "./NavBar.Component";

export default NavBarComponent;
